var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "475" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { color: "pa-2" } },
            [
              _c(
                "v-card-title",
                [
                  _c("div", { staticClass: "text-h2-headline primary--text" }, [
                    _vm._v(" Messaging Ad Event "),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.setDialog(false)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(" mdi-close "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-card-text", [_c("AdEventForm")], 1),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "", rounded: "" },
                      on: {
                        click: function ($event) {
                          return _vm.setDialog(false)
                        },
                      },
                    },
                    [_vm._v(" ยกเลิก ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", depressed: "", rounded: "" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(" บันทึก ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }